<template>
  <tr class="custom-row" ref="row" :rowId="item.id" :isFolder="isFolder">
    <td v-for="({ value }) in headers" :key="value">
      <slot :item="item">
        <template v-if="value === 'title'">
          <div class="d-flex align-center justify-between">
            <span class="text-truncate">
              <v-icon >{{ isFolder ? 'mdi-folder' : 'mdi-file-video-outline' }}</v-icon>
              <v-btn class="row-title text-capitalize" :disabled="!isFolder" plain @click="$emit('open')">
                {{ item[value] || '--' }}
              </v-btn>
            </span>
            <v-btn class="edit-button ml-2" elevation="2" text x-small :to="editRoute">Edit</v-btn>
            <v-btn class="edit-button ml-2" elevation="2" text x-small @click="$emit('delete')">Delete</v-btn>
          </div>
        </template>
        <template v-else-if="value === 'url'">
          <div class="url text-truncate">
            <v-btn class="text-lowercase " plain :href="item[value]" target="_blank">
              {{ item[value] || '' }}
            </v-btn>
          </div>
        </template>
        <template v-else-if="value === 'last_updated'">
          {{ $moment(item[value]).fromNow() }}
        </template>

        <template v-else-if="value === 'is_active'">
          <div class="text-center">
            <span>
              <v-tooltip top>
                <template v-slot:activator="{on}">
                  <v-icon v-on="on"
                    :class="{ 'error--text': !item[value], 'primary--text': item[value] }"
                  >
                    mdi-circle
                  </v-icon>
                </template>
                <span>{{ item[value] ? 'Active' : 'Inactive'}}</span>
              </v-tooltip>
            </span>
          </div>
        </template>
        <template v-else>
          <v-btn elevation="2" text x-small @click="$emit('change-folder')">Change folder</v-btn>
        </template>
      </slot>
    </td>
  </tr>
</template>

<script>
let dragRow;

export default {
  name: "JumpStartRow",
  data: () => ({
    checked: false,
    eventListeners: null,
  }),
  computed: {
    row() {
      return this.$refs.row;
    },
    editRoute() {
      return {
        path: `jump-start/${this.isFolder ? 'folders' : 'videos'}/${this.item.id}`,
        query: this.currentFolderId ? { parentId: this.currentFolderId } : {},
      };
    }
  },
  mounted() {
    this.addEvents();
  },
  beforeDestroy() {
    this.removeEventListeners();
  },
  methods: {
    addEvents() {
      const dragStart = () => {
        dragRow = this.row;
      };

      const dragOver = (e) => {
        const allowDrop = this.isFolder && dragRow !== this.row;

        if (allowDrop) {
          e.preventDefault();
          e.dataTransfer.dropEffect = 'move';
        }

        this.row.classList.toggle('row-drag-over', allowDrop);
      };

      const dragLeave = () => {
        this.row.classList.toggle('row-drag-over', false);
      };

      const drop = () => {
        const eventToEmit = {
          folderId: parseInt(this.row.getAttribute('rowId'), 10),
          dragItem: {
            id: parseInt(dragRow.getAttribute('rowId'), 10),
            isFolder: Boolean(dragRow.getAttribute('isFolder')),
          },
        };

        if (dragRow !== this.row && this.isFolder) {
          this.$emit('row-drop', eventToEmit);          
        }

        this.row.classList.toggle('row-drag-over', false);
        dragRow = null;
      };

      const dragEnd = () => {
        this.row.classList.toggle('row-drag-over', false);
        dragRow = null;
      };

      this.eventListeners = [
        { name: 'dragstart', handler: dragStart },
        { name: 'dragover', handler: dragOver },
        { name: 'dragleave', handler: dragLeave },
        { name: 'drop', handler: drop },
        { name: 'dragend', handler: dragEnd },
    ];

      for (const l of this.eventListeners) {
        this.row.addEventListener(l.name, l.handler);
      }
    },
    removeEventListeners() {
      if (this.eventListeners?.length > 0) {
        for (const l of this.eventListeners) {
          this.row?.removeEventListener(l.name, l.handler);
        }

        this.eventListeners.length = 0;
      }
    },
  },
  props: {
    isFolder: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    headers: {
      type: Array,
      default: () => [],
    },
    currentFolderId: {
      type: Number,
      default: () => null,
    },
  },
};
</script>

<style scoped lang="scss">
  .custom-row:hover .edit-button {
    visibility: visible;
  }

  .edit-button {
    visibility: hidden;
  }

  .row-title[disabled] {
    color: rgba(0, 0, 0, 0.87) !important;
  }

  .row-drag-over {
    background: #f5f9fd;
  }

  .url {
    max-width: 150px;
  }
</style>